<div class="modal-header">
  <h4 class="modal-title">Restablecer contraseña</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="close(false)"></button>
</div>
<div class="modal-body">
  <p>Por favor, introduce tu nombre para restablecer tu contraseña.</p>

  <div class="steps-indicator" aria-label="Pasos para restablecer contraseña">
    <div class="step-item">
      <span class="step-icon" aria-hidden="true">
        <i class="fa-solid fa-envelope"></i>
        <span class="step-number">1</span>
      </span>
      <span class="step-label">Solicita el código</span>
    </div>

    <span class="step-connector" aria-hidden="true"></span>

    <div class="step-item">
      <span class="step-icon" aria-hidden="true">
        <i class="fa-solid fa-shield-keyhole"></i>
        <span class="step-number">2</span>
      </span>
      <span class="step-label">Valida el código</span>
    </div>
  </div>


  <div class="card">
    <div class="card-body">
      <form #userForm="ngForm" (ngSubmit)="sendToken()">

        <div class="row">
          <div>
            <label for="username" class="form-label required ">Nombre de usuario</label>
            <input type="text" class="form-control" id="username" [required]="true" [appAutofocus]="true"
              [(ngModel)]="username"
              name="username">
          </div>
        </div>
        <div class="row">
          <div>
            <label for="telefonoEmail" class="form-label required ">Correo/Telefono registrado</label>
            <input type="text" class="form-control" id="telefonoEmail" [required]="true"
              [(ngModel)]="telefonoEmail"
              name="telefonoEmail">
          </div>
        </div>
        <div class="row">

          <div class="mt-2">
            <input type="submit" [disabled]="!userForm.valid" class="btn btn-outline-primary  " id="token"
              name="token"
              value="Solicita el código">
          </div>
        </div>
      </form>

    </div>
  </div>

  @if (tokenSent())
  {

  <div class="card mt-4">
    <div class="card-body">

      <form #tokenForm="ngForm" (ngSubmit)="validateToken()">


        <div class="row">
          <div class="col-sm-12 ">

            <div class="">
              <label for="token" class="form-label required ">Valida el código</label>
              <input type="submit" style="width:100px" type="text" class="form-control" id="token" [required]="true"
                [appAutofocus]="tokenSent()"
                maxlength="6"
                [(ngModel)]="token"
                name="token">
            </div>
          </div>
        </div>


        <div class="row">

          <div class="mt-2">
            <input [disabled]="!tokenForm.valid" type="submit" class="btn btn-outline-primary  " id="token" name="token"
              value="Validar código ...">
          </div>
        </div>


      </form>
    </div>
  </div>

  }


</div>
<app-problem-details></app-problem-details>

<div class="modal-footer">
  <button type="button" class="btn btn-outline-secondary" (click)="close(false)">Cerrar</button>
</div>